import { type default as TabViewState, TabType } from "../store/schema/TabViewState";
import { getStore } from "../store/tabStore";
import { errorThatWillCauseAlert } from "owa-trace";

export default function getTabsByTabType(type: TabType): TabViewState[] {
    return getStore().tabs.filter(tab => tab.type == type);
}

export function getFullOptionsTab(): TabViewState | undefined {
    const tabs = getTabsByTabType(TabType.FullOptions);
    
    if (tabs.length > 1) {
        errorThatWillCauseAlert("We are having more than 1 FullOptions Projection Tab");
    }
    
    if (tabs.length === 0) {
        errorThatWillCauseAlert("We are trying to get FullOptions Projection Tab, when it does not exist");
        
        return undefined;
    }
    
    return tabs[0];
}

export function getFileErrorTab(): TabViewState | undefined {
    const tabs = getTabsByTabType(TabType.FileError);
    
    if (tabs.length > 1) {
        errorThatWillCauseAlert("We are having more than 1 FileError Tab");
    }
    
    if (tabs.length === 0) {
        errorThatWillCauseAlert("We are trying to get FileError Tab, when it does not exist");
        
        return undefined;
    }
    
    return tabs[0];
}
